import { sameContext, sameRows } from '@/hooks/selectEqual';
import { ANON_IDENTITY, usePort, useRowboat, useSelect } from '@/rowboat';
import { getCaptureContext } from '@/services/captureContext';
import { listEstates } from '@/services/estateService';

/** The live projects, and the active one: the capture context's, else the first, else null. */
export function useActiveEstate() {
  const graph = useRowboat();
  const { author } = usePort();
  // Anonymous users act as ANON_IDENTITY (never ""): their rows live in the local anon
  // store and are adopted into the account on signup.
  const actor = author ?? ANON_IDENTITY;
  const context = useSelect(() => getCaptureContext(graph, actor), sameContext);
  const estates = useSelect(() => listEstates(graph), sameRows);
  const activeEstate = estates.find((e) => e.id === context.estateId) ?? estates[0] ?? null;
  return { estates, activeEstate };
}
